/**
 * bootprompt.js locale configuration
 * locale : Dutch
 * author : Bas ter Vrugt
 */

import { addLocale } from "../bootprompt";

addLocale("nl", {
  OK: "OK",
  CANCEL: "Annuleren",
  CONFIRM: "Accepteren",
});
